import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  Parent27xjh1mdkxxuk as Parent,
  IncomeRangeprzolg293f44 as IncomeRange,
  Family2k7vz7ddyergb as Family,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { Addresspdncepxooezp as Address } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { FamiliesListPage2r5h75kkdixvz as FamiliesListPage } from './FamilyListPage.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { toast4hp3bb4ymp24 as toast } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { FamilyDetailPage2yycb034kbs09 as FamilyDetailPage } from './FamilyDetailPage.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { Formjae7dnqjclc3 as Form } from '../components/form.mjs';
import { Draftj5auffrm1u2b as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { maxWidth22r11xnm7d4h4 as maxWidth } from '../components/view-utilities.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { familyForm1exz237lcn7kd as familyForm } from './familyComponents.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { CanBlockBacknswc7za76703 as CanBlockBack } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/CanBlockBack.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function actionBar($this, $receiver) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($receiver.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $receiver.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_0 = themed(element, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Button())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, NewFamilyPage$actionBar$lambda);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  onClick(element_0, VOID, VOID, VOID, NewFamilyPage$actionBar$slambda(element_0));
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  var this_1 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Space())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_2 = themed(element, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_3 = themed(this_2, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Button())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_3.willAddChild_hz2iwc_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  element_3.willAddChild_hz2iwc_k$(element_4);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
  element_4.invoke_bnq13k_k$(tmp_4, NewFamilyPage$actionBar$lambda_0);
  element_4.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_4);
  element_3.set_action_2ds022_k$(Action('Add family', VOID, VOID, VOID, VOID, VOID, NewFamilyPage$actionBar$slambda_0($this, element_3)));
  element_3.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  $receiver.addChild_2qpft2_k$(element);
}
function NewFamilyPage$_get_title_$lambda_kqwgt9($this$remember) {
  return $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyNewFamilyTitle_u18ivz_k$();
}
function NewFamilyPage$family$lambda($this$Draft) {
  return new (Family())(VOID, VOID, new (Parent())('', ''), VOID, VOID, new (IncomeRange())(), VOID, new (Address())('', VOID, '', ''));
}
function NewFamilyPage$actionBar$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function NewFamilyPage$actionBar$slambda($$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    get_pageNavigator($$this$button.get_context_h02k06_k$()).reset_diztr_k$(new (FamiliesListPage())());
    return Unit_instance;
  }), 0);
}
function NewFamilyPage$actionBar$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyAddFamilyButton_qgzmly_k$();
}
function NewFamilyPage$actionBar$slambda_0(this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_issues(this$0.family_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_0, $completion)).isEmpty_y1axqb_k$()) {
      yield* this$0.get_showValidation_c0zzxd_k$().set_revjhg_k$(true, $completion);
      this$0.formIssuesDialog$default_8ey6bo_k$($$this$button.get_context_h02k06_k$());
      return Unit_instance;
    }
    var tmp_0;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.showSecondParent_1;
    if (!(yield* await_1(this_1, $completion))) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = this$0.family_1;
      var tmp$ret$3 = yield* await_0(this_2, $completion);
      tmp_0 = yield* this$0.family_1.set_revjhg_k$(tmp$ret$3.copy$default_8deers_k$(VOID, VOID, VOID, null), $completion);
    }
    var saved = yield* this$0.family_1.publish_xq9q2e_k$($completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = get_currentSessionNotNull();
    yield* (yield* await_0(this_3, $completion)).get_families_is4v1x_k$().add_co22jy_k$(saved, $completion);
    var tmp_1 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = get_strings(AppState_getInstance());
    var tmp$ret$5 = yield* await_1(this_4, $completion);
    toast(tmp_1, tmp$ret$5.get_familyAddedToast_2w0cdo_k$());
    get_pageNavigator($$this$button.get_context_h02k06_k$()).replace_7qh33u_k$(new (FamilyDetailPage())(saved._id_1));
    return Unit_instance;
  }), 1);
}
function NewFamilyPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyAddPageTitle_rl7n91_k$();
}
function NewFamilyPage$render$lambda_0($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
var NewFamilyPageClass;
function NewFamilyPage() {
  if (NewFamilyPageClass === VOID) {
    class $ extends Form() {
      constructor() {
        super();
        var tmp = this;
        tmp.family_1 = validated(Draft(NewFamilyPage$family$lambda));
        this.showSecondParent_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, NewFamilyPage$_get_title_$lambda_kqwgt9);
      }
      onNavigateAwayAttempt_vrrtsh_k$() {
        return !(ReactiveState__getOrNull_impl_1asnfp(this.family_1.get_changesMade_d6j01d_k$().get_state_wc71uu_k$()) === true);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (TextView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
        element_0.invoke_bnq13k_k$(tmp_1, NewFamilyPage$render$lambda);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (Separator())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        element.willAddChild_hz2iwc_k$(element_1);
        element_1.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_1);
        actionBar(this, element);
        familyForm(this, element, this.family_1, this.showSecondParent_1);
        actionBar(this, element);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Separator())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        element.willAddChild_hz2iwc_k$(element_2);
        element_2.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_2 = shownWhen(element, VOID, VOID, NewFamilyPage$render$lambda_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (Space())(this_2.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_3);
        this_2.willAddChild_hz2iwc_k$(element_3);
        element_3.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_3);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'NewFamilyPage', NewFamilyPage, VOID, [Page(), CanBlockBack()]);
    NewFamilyPageClass = $;
  }
  return NewFamilyPageClass;
}
//region block: exports
export {
  NewFamilyPage as NewFamilyPageoco5erkooy02,
};
//endregion

//# sourceMappingURL=NewFamilyPage.mjs.map
